import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Util} from "../../app/util";
import {CONFIG} from "../../app/config";
import {ENUM} from "../../app/enum";
import {DomSanitizer} from "@angular/platform-browser";

export enum TConviteSeta {csNone, csFree, csSeco, csSuma}
export enum TConviteShow {csLote, csList, csLoja, csNovo}

@Component({
    selector: 'app-convite',
    templateUrl: 'app-convite.html'
})

export class AppConvite {

    TConviteSeta: any = TConviteSeta;

    ENUM: any = ENUM;
    config: any;

    brandedColor: string;

    @Input('branded') public branded: any;
    @Input('convite') public convite: any;
    @Input('entraki') public entraki: boolean;
    @Input('checkin') public checkin: boolean;
    @Input('usuario') public usuario: any;

    @Output('convite-seta') private _seta: EventEmitter<any> = new EventEmitter();

    constructor(public util: Util, public sanitizer: DomSanitizer) {

        this.config = CONFIG;

    }

    ngOnInit() {

        if (!this.entraki) this.brandedColor = this.branded.BrandedCora;
        if ( this.entraki) this.brandedColor = this.config.negative(this.branded.BrandedCora);

        if ( this.entraki && typeof this.convite.conviteSeta == 'undefined') {
            let free = this.mostrar(TConviteSeta.csFree);
            let seco = this.mostrar(TConviteSeta.csSeco);
            let suma = this.mostrar(TConviteSeta.csSuma);
            let soma = (free ? 1 : 0) + (seco ? 1 : 0) + (suma ? 1 : 0);

                 if (soma == 1 && free) this.convite.conviteSeta = TConviteSeta.csFree;
            else if (soma == 1 && seco) this.convite.conviteSeta = TConviteSeta.csSeco;
            else if (soma == 1 && suma) this.convite.conviteSeta = TConviteSeta.csSuma;
            else                        this.convite.conviteSeta = TConviteSeta.csNone;
        }

    }

    height50(conviteSeta: TConviteSeta): boolean {

        let seta = this.convite.conviteSeta;
        let free = this.convite.ConviteFree;
        let seco = this.convite.ConviteSeco;
        let suma = this.convite.ConviteSuma;

        if (conviteSeta == TConviteSeta.csFree) return !this.entraki && (seta >= TConviteSeta.csSeco && free);
        if (conviteSeta == TConviteSeta.csSeco) return !this.entraki && ((seta == TConviteSeta.csSuma && seco) || (seta == TConviteSeta.csFree && free && seco));
        if (conviteSeta == TConviteSeta.csSuma) return !this.entraki && ((seta == TConviteSeta.csSeco && suma) || (seta == TConviteSeta.csFree && free && suma));

    }

    opacity3(conviteSeta): boolean {

        let seta = this.convite.conviteSeta;
        let free = this.convite.ConviteFree;
        let seco = this.convite.ConviteSeco;
        let suma = this.convite.ConviteSuma;

        if (conviteSeta == TConviteSeta.csFree) return !this.entraki && (!free && seta != TConviteSeta.csFree);
        if (conviteSeta == TConviteSeta.csSeco) return !this.entraki && ((seta == TConviteSeta.csNone) || (seta == TConviteSeta.csFree && (!free || !seco)));
        if (conviteSeta == TConviteSeta.csSuma) return !this.entraki && ((seta == TConviteSeta.csNone) || (seta == TConviteSeta.csFree && (!free || !suma)));
        
    }

    conviteInfo(): boolean {

        let seta = this.convite.conviteSeta;
        let free = this.convite.ConviteFree;
        let seco = this.convite.ConviteSeco;
        let suma = this.convite.ConviteSuma;

        return !this.entraki && seta == TConviteSeta.csFree && (!free || (free && !seco && !suma));
        
    }

    mostrar(conviteSeta: TConviteSeta): boolean {

        //VoucherSeta ~> Profile tem Voucher
        if (this.entraki && this.checkin && this.convite.VoucherSeta) {
            return (this.convite.VoucherSeta == conviteSeta);
        }

        let free = this.convite.ConviteFree || (this.usuario && this.usuario.UsuarioDoor);
        let seco = this.convite.ConviteSeco;
        let suma = this.convite.ConviteSuma;

        if (conviteSeta == TConviteSeta.csFree) return !this.entraki || (this.entraki && free) || (this.entraki && (seco+suma) == 0);
        if (conviteSeta == TConviteSeta.csSeco) return !this.entraki || (this.entraki && seco > 0);
        if (conviteSeta == TConviteSeta.csSuma) return !this.entraki || (this.entraki && suma > 0);

    }

    _emitBtn(seta: TConviteSeta) {

        this._seta.emit(seta);

    }

}



// WEBPACK FOOTER //
// ./src/components/app-convite/app-convite.ts